import { RRule } from '@guestgoodie/helpers'

import { MonthlyOptions } from './MonthlyOptions'
import { MultiNumberSelect } from './MultiNumberSelect'

export function YearlyOptions({
  value,
  onChangeOption
}: {
  value: RRule
  onChangeOption: (options: Partial<RRule['origOptions']>) => void
}) {
  return (
    <div className="flex flex-col gap-1">
      <MultiNumberSelect
        value={value.options.bymonth}
        onChange={bymonth => onChangeOption({ bymonth })}
        type="months"
      />
      <MonthlyOptions value={value} onChangeOption={onChangeOption} />
    </div>
  )
}
